import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Select from "ui/molecules/Select";
import FormControl from "@mui/material/FormControl";

const Filters = ({ business, userBusinesses, handleSelect }: any) => {
  return (
    <TopContainer>
      <FormControl fullWidth>
        <Select
          id='business'
          mapKey='code'
          name='business'
          margin='normal'
          label='Seleccione Finca'
          value={business || ""}
          onChange={handleSelect}
          dataSource={userBusinesses || []}
          mapValue='fullName'
        />
      </FormControl>
    </TopContainer>
  );
};

export default Filters;

const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;
